module.exports = __webpack_public_path__ + "img/logo.f9e7e4c2.png";